function runWhenIdle(cb: () => void) {
  if ('requestIdleCallback' in window) {
    // @ts-ignore
    window.requestIdleCallback(cb, { timeout: 2200 })
  } else {
    setTimeout(cb, 800)
  }
}

export function initAdsenseOnPage(nonPersonalized = false) {
  if (process.server) return

  runWhenIdle(() => {
    const ads = document.querySelectorAll('.adsbygoogle')

    ads.forEach((ad) => {
      if (ad.getAttribute('data-adsbygoogle-status')) return

      if (ad.getAttribute('data-ads-init') === '1') return
      ad.setAttribute('data-ads-init', '1')

      try {
        ;(window.adsbygoogle = window.adsbygoogle || []).push({})
      } catch (e) {}
    })
  })
}
